import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Table, Select, Input, Button, Tooltip, Modal } from "antd";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import { req_page_lrs_spaceInformation } from "../../api";

import TimeModalConfig from "./time-modal-config";

class TimeManagement extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    isShowConfigModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_lrs_spaceInformation(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "所在大樓",
        dataIndex: "BuildingName",
        width: 25,
        responsive: ["md"],
      },
      {
        title: "空間編號",
        dataIndex: "RoomCode",
        width: 25,
      },
      {
        title: "空間名稱",
        dataIndex: "RoomTwName",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "管理單位",
        dataIndex: "ServiceUnitName",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "管理人",
        dataIndex: "ConfirmorATwName",
        width: 25,
      },
      {
        title: "",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          return (
            <>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => this.handle_show_ui_modal("CONFIG", item)}
              >
                <i className="fa fa-calendar"></i> 時段設定
              </button>
            </>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    switch (type) {
      case "CONFIG":
        this.setState({ isShowConfigModal: true });
        break;
      default:
    }
    this.setState({ item: item });
  };

  //////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      isShowConfigModal,
    } = this.state;
    const title = (
      <span>
        <Select
          value={searchField}
          style={{ width: 100 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="RoomCode">空間編號</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search"></i> 查詢
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
        <p></p>
      </span>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 460 }}
          loading={loading}
          rowKey="Uid"
          columns={this.columns}
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowConfigModal}
          width={"90%"}
          onOk={() => {
            this.setState({ isShowConfigModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isShowConfigModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <TimeModalConfig space={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(TimeManagement);
